import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SubNav from "../../../Shared/SubNav";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import socket from "../../../context/socket";
import axios from "axios";
import _ from "lodash";
import InvestmentAmountData from "./cards/InvestmentAmountData";
import RetirementData from "./cards/RetirementData";
import CarPurchaseData from "./cards/CarPurchaseData";
import LoanPrepaymentData from "./cards/LoanPrepaymentData";
import DreamHome from "./cards/DreamHome";
import VacationData from "./cards/VacationData";
import EmergencyFundData from "./cards/EmergencyFundData";
import ChildrensMarriageData from "./cards/ChildrensMarriageData";
import ChildrensEducationData from "./cards/ChildrensEducationData";
import OtherData from "./cards/OtherData";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../../../redux/client/clientSlice";
import Swal from "sweetalert2";
import api from "../../../utils/api";
import { formatRupees } from "../../../utils/inputsValidation";

const PlanYourGoals = () => {
  const [selectedCard, setSelectedCard] = useState([]);
  const roomId = new URLSearchParams(useLocation().search).get("clientId");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [finalResultData, setFinalResultData] = useState({});
  const [planYourGoals, setPlanYourGoals] = useState([]);
  const [children, setChildren] = useState([]);
  const [isCardSelectedOnce, setIsCardSelectedOnce] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselRef = useRef(null);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (carouselRef.current) {
  //       const current = carouselRef.current.state.currentSlide;
  //       if (current !== currentSlide) {
  //         console.log("Detected slide change:", current);
  //         socket.emit("carousel-sync", {
  //           room: roomId,
  //           currentSlide: current,
  //         });
  //       }
  //     }
  //   }, 300);
  //   return () => clearInterval(interval);
  // }, [currentSlide,roomId]);
  // console.log("finalResultData",finalResultData);
  // console.log("children",children);
  //  console.log("selectedCard",selectedCard);

  console.log("selectedCard", selectedCard);




  const { clientData, loading: clientLoading, error: clientError, } = useSelector((state) => state.client);

  useEffect(() => {
    dispatch(fetchClientData(roomId));
    setPlanYourGoals(clientData?.dreamPoints);
    // console.log('my-1',clientData.dreamPoints);

  }, [selectedCard])

  useEffect(() => {
    if (
      !isCardSelectedOnce &&
      clientData?.dreamPoints &&
      Array.isArray(clientData.dreamPoints)
    ) {
      setPlanYourGoals(clientData.dreamPoints);
      setChildren(clientData?.children);

      const selecteddata = clientData.dreamPoints.filter(item => item.priority > 0);
      const smallestPriority = selecteddata?.length
        ? Math.min(...selecteddata.map(item => item.priority))
        : null;

      const smallestPriorityItem = selecteddata.find(item => item.priority === smallestPriority);

      if (smallestPriorityItem) {
        setSelectedCard(smallestPriorityItem);
        setIsCardSelectedOnce(true); // ✅ Do this only once
      }
    }
  }, [clientData, isCardSelectedOnce, selectedCard]);



  useEffect(() => {
    api
      .get(
        `advisor/personal_finance_ratio_6/${roomId}`
      )
      .then((response) => {
        const data = response?.data;
        setFinalResultData(data?.final_result);
        // setPlanYourGoals(data?.client?.dreamPoints);
        // setChildren(data?.client?.children);
        // const selecteddata = data?.client?.dreamPoints?.filter(
        //   (item) => item.priority > 0
        // );

        // console.log("selecteddata", selecteddata);
        // setSelectedCard(selecteddata[0]);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [roomId]);

  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      console.log('emited selectedCard', selectedCard);

      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
        },
      });
    }, 300),
    [
      selectedCard,
      roomId,
    ]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [
    selectedCard,
    debouncedEmitMessage,
  ]);

  const handleCardClick = (card) => {
    setSelectedCard(card);

    // STEP 1 — Build advisor-goals array (same as carousel)
    const advisorGoals = Array.from(
      new Map(
        planYourGoals
          ?.filter(item => item.priority > 0)
          ?.sort((a, b) => a.priority - b.priority)
          ?.map(item => [item._id, item])
      ).values()
    );

    // STEP 2 — Find exact index of clicked card
    const advisorIndex = advisorGoals.findIndex(g => g._id === card._id);

    console.log("👉 Advisor sending index:", advisorIndex, "card:", card._id);

    // STEP 3 — Emit this index + cardId
    socket.emit("gateway", {
      room: roomId,
      cardId: card._id,
      advisorIndex: advisorIndex
    });
  };


  const getCardStyle = (cardId) => ({
    backgroundColor:
      selectedCard && selectedCard?._id === cardId ? "#f1fcf8" : "white",
    border:
      selectedCard && selectedCard?._id === cardId
        ? "1px solid #52b58c"
        : "2px solid #ddd",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    boxShadow:
      selectedCard && selectedCard?._id === cardId
        ? "0 4px 8px rgba(0, 0, 0, 0.2)"
        : "0 4px 8px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    width: "95%",
    height: "100px",
  });

  const handleRetirementComplete = (result) => {
    sessionStorage.setItem(
    `retirementResult_${roomId}`,
    JSON.stringify(result)
  );
  const nextUrl = `/goal-tracker?clientId=${roomId}`;
  socket.emit("navigate", {
    room: roomId,
    url: nextUrl,
  });

  navigate(nextUrl);
};
  const handleNext = () => {

    const hasValidGoal = clientData?.dreamPoints
      .some(
        (goal) =>
          goal.status === 1 &&
          goal.priority > 0 &&
          Array.isArray(goal.action_data) &&
          goal.action_data?.length > 0
      );

    // console.log("hasValidGoal", hasValidGoal);

    if (hasValidGoal) {
      const nextUrl = `/goal-tracker?clientId=${roomId}`;
      const nextUrl2 = `/goal-tracker`;

      socket.emit("navigate", { room: roomId, url: nextUrl2 });
      navigate(nextUrl);
    } else {
      Swal.fire({
        icon: "warning",
        title: "No Valid Goal Found",
        text: "Please select at least one goal with priority, status active, and action data.",
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
    }
  };



  const handleBack = () => {
    const prevUrl = `/dreams-into-action?clientId=${roomId}`;
    const prevUrl2 = `/dreams-into-action`;

    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  const excludedIds = [
    "66cd75c2ec2e16f636c838c3",
    "66cd75b6ec2e16f636c838c2",
    "66cd75d7ec2e16f636c838c5",
    "66cd7582ec2e16f636c838be",
    "66cd7591ec2e16f636c838bf",
    "66cd759eec2e16f636c838c0",
    "66cd75aaec2e16f636c838c1",
    "66d0280c9a75443e96fd3411",
    "66d028759a75443e96fd3412",
  ];

  // ---------------------------------------------
  const [dreamsIntoActionData, setDreamsIntoActionData] = useState({});
  const getCardData = async () => {
    try {
      const response = await api.get(
        `advisor/get_master_data/dream_action_points`
      );
      setDreamsIntoActionData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    getCardData();
  }, [roomId]);
  // ---------------------------------------------

  return (
    <>
      <div className="container minht position-relative">
        <div className="row ">
          <div className="col-md-10 col-12">
            <h2 className="fw-light">Plan your Goals</h2>
          </div>
          <div className="col-md-2 d-none d-md-block">
            <span className="para verify">Monthly Surplus</span>
            <p className="fs-14 percen pt-3 ps-3">{finalResultData && Math.round(finalResultData.reserve_to_surplus)}%</p>
            <h5 style={{ marginTop: "-60px" }}>
              {finalResultData && formatRupees(finalResultData.monthly_surplus)}
            </h5>
          </div>
          <div className="col-md-2 d-block d-md-none">
            <span className="para verify">Monthly Surplus</span>
            <p className="fs-14 percen pt-3 ps-3 position-relative" style={{ left: "85%" }}>{finalResultData && Math.round(finalResultData.reserve_to_surplus)}%</p>
            <h5 style={{ marginTop: "-60px" }}>{finalResultData && formatRupees(finalResultData.monthly_surplus)}</h5>
          </div>
        </div>
        <div className="row   my-4">
          <div className="col-12">
            {Array.isArray(planYourGoals) && planYourGoals.length > 0 &&
              <Carousel
                ref={carouselRef}

                afterChange={(nextSlide) => {
                  console.log("Current slide:", nextSlide);
                  setCurrentSlide(nextSlide);
                }}
                infinite={false}
                swipeable={true}
                additionalTransfrom={0}
                arrows
                centerMode={false}
                className=""
                // containerClass="container"
                draggable
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                responsive={{
                  desktop: {
                    breakpoint: { max: 3000, min: 1024 },
                    items: 4,
                    partialVisibilityGutter: 40,
                  },
                  mobile: {
                    breakpoint: { max: 464, min: 0 },
                    items: 1,
                    partialVisibilityGutter: 30,
                  },
                  tablet: {
                    breakpoint: { max: 1024, min: 464 },
                    items: 2,
                    partialVisibilityGutter: 30,
                  },
                }}
              >

                {Array.from(
                  new Map(
                    planYourGoals
                      ?.filter((item) => item.priority > 0)
                      ?.sort((a, b) => a.priority - b.priority) // Sort by priority (ascending)
                      ?.map((item) => [item._id, item]) // Create a map with unique _id keys
                  )?.values()
                )?.map((item) => (
                  <Card
                    key={item._id}
                    className="image-container Loan brdr increase-size"
                    onClick={() => handleCardClick(item)}
                    style={getCardStyle(item._id)}
                  >
                    <div className="p-3">
                      <div className="row">
                        <div className="col">
                          {/* <h5 className="clrgreen">{item.text}</h5> */}

                          <div
                            className="reward-text-wrapper "
                            style={{
                              maxHeight: '80px',
                              overflowY: 'auto',
                              lineHeight: '1.3',
                              marginTop: "3px",
                              fontSize: '22px',
                              fontWeight: "500"
                            }}
                          >
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 200, hide: 400 }}
                              overlay={
                                <Tooltip id={`tooltip-${item._id}`}>
                                  {item.text}
                                </Tooltip>
                              }
                            >
                              <p className="clrgreen mb-0">
                                {(() => {
                                  const words = item.text?.trim().split(/\s+/) || [];
                                  let totalLength = 0;
                                  const maxChar = 23;  // 👈 adjust character limit based on your card width
                                  let shouldShowEllipsis = false;

                                  const visibleWords = [];

                                  for (let i = 0; i < words.length; i++) {
                                    totalLength += words[i].length + 1; // +1 for space
                                    if (totalLength <= maxChar) {
                                      visibleWords.push(words[i]);
                                    } else {
                                      shouldShowEllipsis = true;
                                      break;
                                    }
                                  }

                                  return visibleWords.map((word, idx) => (
                                    <React.Fragment key={idx}>
                                      {word}
                                      {idx === 0 && <br />}
                                      {idx === visibleWords.length - 1 && shouldShowEllipsis && '...'}
                                      {" "}
                                    </React.Fragment>
                                  ));
                                })()}

                              </p>
                            </OverlayTrigger>
                          </div>
                        </div>
                        <div className="col">
                          <img
                            src={
                              dreamsIntoActionData?.master_values?.find((m) => m._id === item._id)?.imgSrc
                                ? `assets/images/goal-images/${dreamsIntoActionData.master_values.find((m) => m._id === item._id).imgSrc}`
                                : `assets/images/goal-images/Custom-Goal.svg`
                            }

                            alt=""
                            className="float-end text-color goalIcons"
                            width={88}
                            height={56}
                          />
                        </div>
                      </div>
                    </div>
                  </Card>
                ))}
              </Carousel>
            }
          </div>
        </div>
        <div className="row mt-md-3 mt-4">
          <div className="col">
            <div className="row">
              <div className="col-md-8 col-10">
                <h3 className="clrgreen my-3 ms-2">{selectedCard?.title}</h3>
              </div>
            </div>

            {/* childrensEducationInputData */}
            {selectedCard?._id === "66d028759a75443e96fd3412" && (
              <>
                <ChildrensEducationData
                  roomId={roomId}
                  card_id={"66d028759a75443e96fd3412"}
                  planYourGoals={planYourGoals}
                  children={children}
                />
              </>
            )}

            {/* childrensMarriageInputData */}
            {selectedCard?._id === "66d0280c9a75443e96fd3411" && (
              <>
                <ChildrensMarriageData
                  roomId={roomId}
                  card_id={"66d0280c9a75443e96fd3411"}
                  planYourGoals={planYourGoals}
                  children={children}
                />
              </>
            )}

            {/* investmentAmountInputData */}
            {selectedCard?._id === "66cd75c2ec2e16f636c838c3" && (
              <>
                <InvestmentAmountData
                  roomId={roomId}
                  card_id={"66cd75c2ec2e16f636c838c3"}
                  planYourGoals={planYourGoals}
                />
              </>
            )}

            {/* carPurchaseInputData */}
            {selectedCard?._id === "66cd75b6ec2e16f636c838c2" && (
              <>
                <CarPurchaseData
                  roomId={roomId}
                  card_id={"66cd75b6ec2e16f636c838c2"}
                  planYourGoals={planYourGoals}
                />
              </>
            )}

            {/* loanPrepaymentInputData */}
            {selectedCard?._id === "66cd75d7ec2e16f636c838c5" && (
              <>
                <LoanPrepaymentData
                  roomId={roomId}
                  card_id={"66cd75d7ec2e16f636c838c5"}
                  planYourGoals={planYourGoals}
                />
              </>
            )}

            {/* retirementInputData */}
            {selectedCard?._id === "66cd7582ec2e16f636c838be" && (
              <>
                <RetirementData
                  roomId={roomId}
                  card_id={"66cd7582ec2e16f636c838be"}
                  planYourGoals={planYourGoals}
                  onComplete={handleRetirementComplete}
                  clientData={clientData}
                />
              </>
            )}

            {/* dream home */}
            {selectedCard?._id === "66cd7591ec2e16f636c838bf" && (
              <>
                <DreamHome
                  roomId={roomId}
                  card_id={"66cd7591ec2e16f636c838bf"}
                  planYourGoals={planYourGoals}
                />
              </>
            )}

            {/* vacationData */}
            {selectedCard?._id === "66cd759eec2e16f636c838c0" && (
              <>
                <VacationData
                  roomId={roomId}
                  card_id={"66cd759eec2e16f636c838c0"}
                  planYourGoals={planYourGoals}
                />
              </>
            )}

            {/* emergencyFundInputData */}
            {selectedCard?._id === "66cd75aaec2e16f636c838c1" && (
              <>
                <EmergencyFundData
                  roomId={roomId}
                  card_id={"66cd75aaec2e16f636c838c1"}
                  planYourGoals={planYourGoals}
                />
              </>
            )}

            {/* otherData */}
            {selectedCard && !excludedIds.includes(selectedCard?._id) && (
              <>
                <OtherData
                  roomId={roomId}
                  card_id={
                    !excludedIds.includes(selectedCard?._id) &&
                    selectedCard?._id
                  }
                  planYourGoals={planYourGoals}
                />
              </>
            )}
          </div>
        </div>
      </div>
      {selectedCard?._id !== "66cd7582ec2e16f636c838be" && (

      <div className="container ">
        <div className="row py-4">
          <div className="col text-end">
            <a href="javascript:void(0);" onClick={handleBack}>
              <img
                className="arrow_next1"
                src="assets/images/left-arrowpng.png"
                alt=""
              />
            </a>
            <a href="javascript:void(0);" className="ms-1" onClick={handleNext}>
              <img
                className="arrow_next"
                src="assets/images/right-arrow.svg"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default PlanYourGoals;
